module.exports = __webpack_public_path__ + "images/social-icons/email-icon.2588cf883199ad73a03f.svg";